<template>
  <div class="approval-template-editor-view h-100">
    <TemplateEditor />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import TemplateEditor from '@/components/jobProfiles/approvals/TemplateEditor.vue';
import { useTracking } from '@/stores/tracking/tracking';

defineOptions({ name: 'ApprovalTemplateEditorView' });

onMounted(() => {
  useTracking().trackPageLoad({ page: 'Approval Template Editor: Open' });
});
</script>
